import { h } from "preact";
import styled from "styled-components";

import { getChatPriceABTesting } from "utils/ABTesting";
import {
  HOST_WEB_PRODUCTION,
  HOST_WEB_STAGING,
} from "utils/constants";
import { numberWithDot } from "utils/number";

import Img from "components/Img";
import Button from "components/Button";
import LawyerImages from "components/LawyerImages";
import ChatIcon from "images/ChatIcon.svg";

import JustikaIconWhite from "../images/justika-white.svg";
import { FormattedMessage } from "react-intl";
import messages from "../messages";

const Container = styled.div`
  flex: 1;
  width: inherit;
  min-width: 320px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #003366;
  padding: 24px;
  border-radius: 4px;
`;

const Content = styled.div`
  width: 100%;
  max-width: 350px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const Title = styled.div`
  font-family: Montserrat;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 22px;
  letter-spacing: 0em;
  text-align: left;
  color: white;
  margin-top: 20px;
`;

const Subtitle = styled.div`
  font-family: Montserrat;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0em;
  text-align: left;
  color: white;
  margin-top: 8px;
  max-width: 350px;
`;

const ServiceName = styled.div`
  font-family: Montserrat;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px;
  letter-spacing: 0em;
  text-align: left;
  color: white;
`;

const PriceContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const ServiceSubtitle = styled.div`
  font-family: Montserrat;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0em;
  text-align: center;
  color: white;
`;

const Price = styled.div`
  margin-left: 8px;
  font-family: Montserrat;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0em;
  text-align: left;
  color: #f4c916;
`;

function getTitleText(props) {
  const cohort = props.matches.cohort;
  switch (cohort) {
    case 'aligator':
    case 'badak':
    case 'cheetah':
      return 'Konsultasi Hukum Online dengan Advokat Pilihan';
    case 'dino':
      return 'Butuh Saran Hukum Cepat dan Terpercaya?';
    default:
      return 'Konsultasi Hukum Online dengan Advokat Pilihan';
  }
}

function getSubtitleText(props) {
  const cohort = props.matches.cohort;
  switch (cohort) {
    case 'aligator':
    case 'badak':
    case 'cheetah':
      return '15.000+ masalah hukum telah dikonsultasikan bersama kami';
    case 'dino':
      return 'Gunakan konsultasi online yang dipercaya +15.000 pengguna';
    default:
      return '15.000+ masalah hukum telah dikonsultasikan bersama kami';
  }
}

const SmallSection = (props) => {
  let HOST = process.env.PREACT_APP_API_URL === 'production' ? HOST_WEB_PRODUCTION : HOST_WEB_STAGING;
  let category = props.matches.category
  let url = props.matches.url
  let version = props.matches.version
  let cohort = props.matches.cohort
  let CTA_URL = `${HOST}/partner/klinik/?utm_source=hukumonline&utm_medium=iframe&utm_campaign=chat&utm_content=uncategorized&category=${category}&url=${url}&cohort=${cohort}&version=${version}`;

  return (
    <Container>
      <Content>
        {cohort == 'cheetah' ?
          null
          :
          <Img
            src={JustikaIconWhite}
            alt="Justika logo white"
            style={{ height: "20px", width: "auto" }}
          />
        }
        <Title id="title">
          {getTitleText(props)}
        </Title>
        <Subtitle id="subtitle">
          {getSubtitleText(props)}
        </Subtitle>
        <div
          style={{
            display: "flex",
            marginTop: "35px",
            marginLeft: "8px",
            alignItems: "center",
          }}
        >
          <LawyerImages size="sm" />
        </div>
        <PriceContainer>
          <ServiceName id="service">
            <FormattedMessage {...messages.consultation_30_minutes} />
          </ServiceName>
          <div style={{ display: "flex", marginTop: "2px" }}>
            <Price id="price">
              <span style={{ fontWeight: '500', textDecoration: 'line-through', color: '#ffffff', marginRight: '4px' }}>{"Rp 50.000"}</span>
              {`Rp ${numberWithDot(getChatPriceABTesting(props))}`}
            </Price>
          </div>
        </PriceContainer>
        <Button
          href={CTA_URL}
          blank="_blank"
          color="yellow"
          size="large"
          style={{ boxShadow: "none" }}
        >
          <div
            style={{
              display: "inline-block",
              width: "30px",
              marginRight: "10px",
            }}
          >
            <Img alt="Chat Icon" src={ChatIcon} style={{ width: "20px" }} />
          </div>
          <FormattedMessage {...messages.cta} />
        </Button>
      </Content>
    </Container>
  );
};

export default SmallSection;
